var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0173 5.01108H14.7613L12.3755 2.62383C11.6074 1.85573 10.6507 1.30337 9.60145 1.02228C8.5522 0.74119 7.44744 0.741272 6.39824 1.02252C5.34903 1.30377 4.39236 1.85627 3.62439 2.62448C2.85641 3.39269 2.30421 4.34954 2.02329 5.39883M1.23879 12.7331V8.98908M1.23879 8.98908H4.98279M1.23879 8.98908L3.62379 11.3763C4.39187 12.1444 5.34863 12.6968 6.39788 12.9779C7.44712 13.259 8.55188 13.2589 9.60108 12.9776C10.6503 12.6964 11.607 12.1439 12.3749 11.3757C13.1429 10.6075 13.6951 9.65062 13.976 8.60133M14.7613 1.26708V5.00958",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/Exchange.1b0a831d12d7ed858f87a3d7fcf1413e.svg";
export { ForwardRef as ReactComponent };